
  import {prepareImageUrl} from '@/helper/ImageHelper';
  import EventJobPostings from '@/components/EventJobPostings.vue';
  import EmployeeSearchBox from '@/components/elements/EmployeeSearchBox.vue';
  import ScreenSize from '@/mixins/ScreenSize';

  export default {
    components: {
      EmployeeSearchBox,
      EventJobPostings,
      RichText: () => import('@/components/elements/RichText'),
    },
    mixins: [ScreenSize],
    props: {
      event: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        event_category_title_singular: '',
        logoUrl: '',
      };
    },
    created() {
      if (this.event.logo) {
        this.logoUrl = prepareImageUrl(this.event.logo.url);
      }
      const categoryMap = {
        Messen: 'Messe',
        Festivals: 'Festival',
        Sportveranstaltungen: 'Sportveranstaltungs',
      };
      const title = this.event.event_category.title;
      this.event_category_title_singular = categoryMap[title] || title;
    },
    methods: {
      formatDate(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return day + '.' + month + '.' + year;
      },
      formatNumber(number) {
        return number
          ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          : '';
      },
    },
  };
